import { useState } from 'react';
import { ResumeCritiqueSuggestion } from '../../services/resume';
import { ResumeCritiqueModal } from './ResumeCritiqueModal';

type ResumeCritiqueProps = {
  onApplySuggestion: (suggestion: ResumeCritiqueSuggestion) => Promise<void>;
  disabled?: boolean;
};

export function ResumeCritique({ onApplySuggestion, disabled }: ResumeCritiqueProps) {
  const [open, setOpen] = useState(false);

  return (
    <div className="resumeSection">
      <h3 className="resumeSectionTitle">AI Critique</h3>
      <div className="resumeSectionActions">
        <button
          type="button"
          onClick={() => setOpen(true)}
          className="resumeButton resumeButtonOutlinePrimary resumeButtonSmall"
          disabled={disabled}
          data-testid="resume-generate-critique"
        >
          Generate AI Critique
        </button>
      </div>

      {open && (
        <ResumeCritiqueModal
          onClose={() => setOpen(false)}
          onApplySuggestion={onApplySuggestion}
        />
      )}
    </div>
  );
}
